module.exports = __webpack_public_path__ + "img/11.13e113a2.png";